import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-description-modal',
    templateUrl: './description-modal.component.html',
    styleUrls: ['./description-modal.component.css'],
    standalone: true,
})
export class DescriptionModalComponent {
  @Input() public data;
  @Output() closeRequested = new EventEmitter<void>();

  private translation: TranslateService = inject(TranslateService);


  getDescription() {
    switch (this.translation.currentLang) {
      case 'it':
        return this.data.descriptionFormatted != null ? this.data.descriptionFormatted : this.data.description;
      case 'en':
        return this.data.descriptionEngFormatted != null ? this.data.descriptionEngFormatted : this.data.descriptionEng;
      default:
        return this.data.descriptionFormatted != null ? this.data.descriptionFormatted : this.data.description;
    }
  }

  close() {
    this.closeRequested.emit();
  }

}
